export default __webpack_public_path__ + "static/jagielly17-d47b62b035bcd136f97e4e05e9601de6.png";